/**
 * Reads firm setting "BCC Firm Contact on Invitations" (IncludeFirmEmail profile flag).
 */
export async function getIncludeFirmEmail(sid: string): Promise<boolean> {
    try {
        const res = await fetch(`getprofile.asp?pname=IncludeFirmEmail&SessionID=${sid}`);
        const textData = await res.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(textData, 'text/xml');
        const includeEmailValue = xmlDoc.getElementsByTagName('IncludeEmail')[0]?.childNodes[0]?.nodeValue;
        if (includeEmailValue !== undefined) {
            return includeEmailValue === '1';
        }
        return false;
    } catch (e) {
        console.log('Unable to get Include Firm Email setting: ', e);
        return false;
    }
}
